<div class="header-container"></div>
<div class="main-content">
  <div class="progress-container"></div>
  <div class="slide-container">
      <div class="wizard-form-container --enter">
        <div class="step-container" role="region" aria-labelledby="step-heading"></div>
        <div class="navigation-container"></div>
      </div>
      <div class="wizard-form-container --leave"></div>
  </div>

  <% if (recaptchaEnabled) { %>
    <% /* Required by https://developers.google.com/recaptcha/docs/faq#id-like-to-hide-the-recaptcha-v3-badge-what-is-allowed */ %>
    <p class="recaptcha-disclaimer">
      <%= I18n.recaptcha_disclaimer_html %>
    </p>
  <% } %>
</div>
